"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseForms = require("nicbase-forms");

var _index = require("../index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DualListIndividuallySelectable = function DualListIndividuallySelectable(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "dual-list-individually-selectable"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "selected-assets"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "individual-selection-buttons-container"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiButton, {
    className: (0, _classnames["default"])('action-button', 'inactive-color-button', {
      'individual-color-button': props.allItemsSelected
    }),
    onClick: props.onAllItemsClicked,
    key: "allButton"
  }, props.textAll), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiButton, {
    className: (0, _classnames["default"])('action-button', 'inactive-color-button', {
      'individual-color-button': !props.allItemsSelected
    }),
    raised: !props.allItemsSelected,
    onClick: props.onIndividualItemsClicked,
    key: "individualButton"
  }, props.textSelectIndividually)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "dual-list-individually-selectable-container"
  }, !props.allItemsSelected && /*#__PURE__*/_react["default"].createElement(_index.DualListControlled, {
    selectableItems: props.selectableItems,
    selectedItems: props.selectedItems,
    onSelectAll: props.onSelectAll,
    onSelect: props.onSelect,
    onDeselectAll: props.onDeselectAll,
    onDeselect: props.onDeselect,
    filterable: props.filterable,
    filterLabel: props.filterLabel,
    disabled: props.disabled,
    displayAssignedItemTotals: props.displayAssignedItemTotals,
    assignedItemsText: props.assignedItemsText,
    notAssignedItemsText: props.notAssignedItemsText
  }))));
};

DualListIndividuallySelectable.propTypes = {
  allItemsSelected: _propTypes["default"].bool,
  onIndividualItemsClicked: _propTypes["default"].func,
  onAllItemsClicked: _propTypes["default"].func,
  selectableItems: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  textAll: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  textSelectIndividually: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  selectedItems: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  onSelect: _propTypes["default"].func,
  onDeselect: _propTypes["default"].func,
  onSelectAll: _propTypes["default"].func,
  onDeselectAll: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  filterable: _propTypes["default"].bool,
  displayAssignedItemTotals: _propTypes["default"].bool,
  filterLabel: _propTypes["default"].string,
  assignedItemsText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  notAssignedItemsText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node])
};

var noop = function noop() {};

DualListIndividuallySelectable.defaultProps = {
  textSelectIndividually: 'Insert selected individually items',
  textAll: 'Insert all selected items',
  filterLabel: _index.DualListControlled.defaultProps.filterLabel,
  assignedItemsText: '',
  notAssignedItemsText: '',
  allItemsSelected: true,
  selectableItems: [],
  selectedItems: [],
  displayAssignedItemTotals: true,
  disabled: false,
  filterable: true,
  onSelect: noop,
  onDeselect: noop,
  onIndividualItemsClicked: noop,
  onAllItemsClicked: noop,
  onSelectAll: noop,
  onDeselectAll: noop
};
var _default = DualListIndividuallySelectable;
exports["default"] = _default;